<template>
  <div>
    <transition name="el-zoom-in-top">
      <el-dialog :visible.sync="$store.state.isLoginShow" :close-on-click-modal="false">
        <div class="loginBox fontPB">
          <div class="boxItem">
            <div class="title">
              <div>{{ $t('dialog.logIn') }}</div>
              <p class="fontPR">{{ $t('dialog.account') }} <span class="fontPM"
                                                                 @click="$store.commit('changeLoginShow',false);$store.commit('changeRegisterShow',true);">{{
                  $t('dialog.signup')
                }}</span></p>
            </div>
            <el-form labelPosition="top" ref="loginForm" :model="form" :rules="rules">
              <el-form-item prop="email" v-if="loginEmail" key="email">
                <div class="formLabel">{{ $t('dialog.accountNo') }}
                  <span v-if="!loginEmail" class="forgot" @click="loginEmail = !loginEmail">{{
                      $t('dialog.loginEmail')
                    }}</span>
                  <span v-else class="forgot" @click="loginEmail = !loginEmail">{{ $t('dialog.loginPhone') }}</span>
                </div>
                <el-input placeholder="you@example.com" v-model="form.email">
                </el-input>
              </el-form-item>

              <el-form-item prop="phone" v-else key="phone" :error="errs.phone">
                <div class="formLabel">{{ $t('dialog.accountNo') }}
                  <span v-if="!loginEmail" class="forgot" @click="loginEmail = !loginEmail">{{
                      $t('dialog.loginEmail')
                    }}</span>
                  <span v-else class="forgot" @click="loginEmail = !loginEmail">{{ $t('dialog.loginPhone') }}</span>
                </div>
                <el-input :placeholder="$t('dialog.pphone')" v-model="form.phone">
                  <el-select v-model="form.areaCode" filterable slot="prepend" :placeholder="$t('dialog.pselect')">
                    <el-option
                      v-for="item in areaCodeList"
                      :key="item.areaCode"
                      :label="`+${item.areaCode}`"
                      :value="`+${item.areaCode}`">
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>

              <el-form-item prop="password">
                <div class="formLabel" solt="label">{{ $t('dialog.pass') }}<span class="forgot fontPM"
                                                                                 @click="$store.commit('changeForgotShow',true);">{{
                    $t('dialog.forgot')
                  }}</span></div>
                <el-input show-password :placeholder="$t('dialog.char')" v-model="form.password"></el-input>
              </el-form-item>
            </el-form>
            <!-- <el-checkbox class="remember" v-model="checked">Remember me</el-checkbox> -->
            <div class="iconGroup">
              <el-button class="fontMB" style="width: 100%;height: 40px;color:#fff;background-color: #fec353;" plain
                         @click="login()">{{ $t('dialog.deng') }}
              </el-button>
              <!-- <el-button class="fontMB" style="width: 45%;height: 40px;color:#fff;background-color: #BABABA;" plain @click="buyGuest()">{{$t('dialog.guest')}}</el-button> -->
            </div>
          </div>
          <div class="boxItem">
            <div class="checkStep" v-if="$store.state.isLoginShow=='login'">
              <el-steps :active="active">
                <el-step></el-step>
                <el-step></el-step>
                <el-step></el-step>
              </el-steps>
            </div>
            <div class="otherTitle">
              <div class="line"></div>
              <div class="signUp fontMR">{{ $t('dialog.signWith') }}</div>
              <div class="line"></div>
            </div>
            <div class="otherIcons fontMB">
              <el-button icon="el-icon-google"
                         style="width: 48%;height: 40px;color:#DB4437;background-color: #fff;border-color:#DB4437; "
                         plain @click="googleLogin();">
                <span>{{ $t('dialog.google') }}</span>
              </el-button>
              <!-- <el-button icon="el-icon-fb" style="width: 48%;height: 40px;color:#3B5998;background-color: #fff;border-color:#3B5998;" plain @click="faceLogin();">
                <span>{{$t('dialog.face')}}</span>
              </el-button> -->
            </div>
          </div>
        </div>
      </el-dialog>
    </transition>
  </div>
</template>
<script>
import areaCodeList from '../assets/area/data';

export default {
  data () {
    var validateEmail = (rule, value, callback) => {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value === '') {
        callback(new Error(this.$t('dialog.pemail')));
      } else if (!myreg.test(value)) {
        callback(new Error(this.$t('dialog.pvemail')));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('dialog.ppass')));
      } else {
        if (value.length < 6) {
          callback(new Error(this.$t('dialog.p6pass')));
        }
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      // var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value === '') {
        callback(new Error(this.$t('dialog.pphone')));
      }
        // else if(!myreg.test(value)){
        //     callback(new Error(this.$t('dialog.pvemail')));
      // }
      else {
        callback();
      }
    };
    return {
      active: 1,
      loginShow: this.$store.state.isLoginShow,
      form: {
        email: '',
        password: '',
        phone: '',
        areaCode: '',
      },
      rules: {
        email: [
          { validator: validateEmail, trigger: 'blur' },
        ],
        password: [
          { validator: validatePass, trigger: 'blur' },
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' },
        ],
      },
      errs: {
        phone: '',
      },
      loginEmail: true,
      checked: false,
      areaCodeList: areaCodeList.province_list,
    };
  },
  mounted () {
    // this.getAreaCode()
    // console.log(areaCodeList.province_list);
  },
  methods: {
    getAreaCode () {
      this.$axios({
        method: 'GET',
        url: '/api/codes',
      }).then((res) => {
        this.areaCodeList = res;
      });
    },
    login () {
      let data;
      if (this.loginEmail) {
        data = {
          username: this.form.email,
          password: this.form.password,
        };
      } else {
        data = {
          username: this.form.phone,
          password: this.form.password,
          phone_area_code: this.form.areaCode,
        };
      }
      // this.$refs.loginForm.validate((valid) => {
      // 	if (valid) {
      // if( !(this.loginEmail && this.areaCode)){
      this.$axios({
        method: 'post',
        url: '/api/authorizations',
        data,
      }).then(res => {
        console.log(res);
        this.$message({
          message: this.$t('btnText.loginSuccess'),
          type: 'success',
          duration: 1800,
          offset: 200,
        });
        this.$refs.loginForm.resetFields();
        this.$store.commit('changeLoginShow', false);
        this.$localStorage.setItem('token', res.access_token);
        this.$localStorage.setItem('token_type', res.token_type);
        this.$store.commit('setToken', res.access_token);
        this.$store.commit('setTokenType', res.token_type);
        this.getUserInfo();
        this.$store.commit('mergeCart');
      });
      // }
      // else {
      // 	this.errs.phone = this.$t("dialog.pselectinfo")
      // }
      // } ,
      //     });
    },
    googleLogin () {
      this.ga.event('register', 'submit', 'google');
      fbq('track', 'register', { content_name: 'google' });
      window.location.href = 'https://www.wennoanimal.com/api/google';
    },
    // faceLogin(){
    // 	this.ga.event('register', 'submit', 'facebook');
    // 	fbq('track', 'register',{content_name:'facebook'});
    // 	window.location.href= "https://www.wennoanimal.com/api/facebook";
    // },
    getUserInfo () {
      this.$axios({
        method: 'get',
        url: '/api/user',
        headers: {
          'Authorization': 'Bearer ' + this.$localStorage.token,
        },
      }).then(res => {
        console.log(res);
        this.$store.commit('setUserId', res.id);
        this.$store.commit('setUserName', res.name);
        this.$store.commit('setUserEmail', res.email);
        this.$store.commit('setNewsletter', res.is_newsletter);
        this.$store.commit('setLanguage', res.language);
      }).catch(error => {

      });
    },
    buyGuest () {
      console.log(this.$route.path);
      if (this.$route.path == '/ShopCart') {
        this.$store.commit('changeLoginShow', false);
        this.$router.push({ path: '/CheckOut' });
      } else {
        this.$store.commit('changeLoginShow', false);
      }
    },
  },
};
</script>
<style scoped>
/deep/ .is-finish .el-step__icon.is-text {
  background: #44D7B6;
}

/deep/ .el-step__head.is-finish {
  color: #fff;
  border-color: #44D7B6;
}

/deep/ .el-dialog {
  width: 70%;
}

/deep/ .remember .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .remember .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fec353;
  border-color: #fec353;
}

/deep/ .remember .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fec353;
}

.el-select {
  width: 100px;
}

.loginBox {
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: #000;
}

.boxItem {
  width: 45%;
  min-height: 300px;
}

.title {
  min-height: 75px;
  word-break: break-word;
}

.title > div {
  font-size: 30px;
  color: #010D3E;
}

.title > p {
  line-height: 30px;
  font-size: 16px;
  color: #9595A4;
}

.title > p > span:hover {
  cursor: pointer;
}

.title > p > span {
  color: #fec353;
}

.formLabel {
  height: 30px;
  line-height: 30px;
  color: #000;
  font-size: 16px;
}

.forgot {
  display: block;
  float: right;
  color: #fec353;
  text-decoration: underline;
}

.forgot:hover {
  cursor: pointer;
}

.iconGroup {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.checkStep {
  float: right;
  width: 150px;
}

.otherTitle {
  height: 20px;
  margin-top: 41px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signUp {
  width: 100px;
  height: 20px;
  text-align: center;
  font-size: 14px;
  color: #D0D0E4;
}

.line {
  flex: auto;
  height: 1px;
  background-color: #D0D0E4;
}

.otherIcons {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

/*手机*/
@media screen and (max-width: 768px) {
  /deep/ .el-dialog {
    width: 85%;
  }
  .loginBox {
    display: block;
  }
  .boxItem {
    width: 100%;
    min-height: auto;
  }
}

@media screen and (max-width: 500px) {
  /deep/ .el-dialog {
    width: 95%;
  }
  .title > div {
    font-size: 24px;
  }
}

/*平板*/
@media screen and (min-width: 768px) and (max-width: 992px) {
  /deep/ .el-dialog {
    width: 80%;
  }
}

/*中等屏幕*/
@media screen and (min-width: 992px) and (max-width: 1200px) {
  /deep/ .el-dialog {
    width: 75%;
  }
}

/*大屏幕*/
@media screen and (min-width: 1200px) {
  /deep/ .el-dialog {
    width: 70%;
    max-width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Login.vue